<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
            div.pull-right.m-t-sm
                button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                    :disabled="onLoading('save-stock-check')",
                    @click="cancel",
                ) Cancel

                button.md-btn.md-raised.m-b-sm.w-xs.green(
                    :disabled="onLoading('save-stock-check')",
                    @click="submit",
                )
                    v-loading(loader="save-stock-check") Create

            nav(aria-label="breadcrumb")
                ol.breadcrumb.white.m-b-0.p-b-0
                    li.breadcrumb-item
                        router-link(to="/") Stock Check
                    li.breadcrumb-item.active Create
    .padding
        .box
            .box-header.dker
                h3 New Stock Check
            .box-divider.m-a-0
            .box-body
                form
                    fieldset(:disabled="onLoading('save-stock-check')")
                        .row
                            .col-md-5
                                .form-group
                                    label Select Outlet
                                    outlet-selector(
                                        :class="{'has-error': errors.has('outlet') }"
                                        v-model="outlet_id",
                                        :use-vuex="false"
                                    )
                                    span.text-danger(v-if="errors.has('outlet')")
                                        | {{ errors.first('outlet') }}

                                .form-group
                                    label Description
                                    textarea.form-control(v-model="description", rows="3")
</template>

<script>
import stockCheckMixin from './stock-check-mixin';
import stockCheckEvent from './stock-check-event';
import { mapActions } from 'vuex';

export default {
    mixins: [stockCheckMixin],

    $_veeValidate: {
        validator: 'new',
    },

    data() {
        return {
            outlet_id: null,
            description: null,
        };
    },

    methods: {
        ...mapActions('stockCheck', ['createStockCheck']),

        cancel() {
            this.$router.push('/');
        },

        async submit() {
            this.errors.clear();

            if (_.isNull(this.outlet_id) || this.outlet_id == 0) {
                this.errors.add({
                    field: 'outlet',
                    msg: 'Outlet field is required',
                });

                return;
            }

            this.startLoading('save-stock-check');

            const params = {
                outlet_id: this.outlet_id,
                description: this.description,
            };

            this.createStockCheck(params).then(stockCheck => {
                this.endLoading('save-stock-check');
                stockCheckEvent.$emit('stock-check-saved');
                this.$router.push(`/${stockCheck.id}`);
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_check/stock-check-create.vue